import { createRouter as createTanStackRouter } from "@tanstack/react-router"
import { routeTree } from "./routeTree.gen"
import GenericError from "~/components/reusable/errors/GenericError"

const auth = undefined!
const trpcUtils = undefined!

export function createRouter() {
  return createTanStackRouter({
    routeTree,
    basepath: "/",
    scrollRestoration: true,
    // Settings pages share one scroll container; reset it rather than restoring the previous offset.
    scrollToTopSelectors: ["[data-scroll-reset]"],
    defaultPreload: "intent",
    defaultErrorComponent: GenericError,
    context: {
      auth,
      trpcUtils,
    },
  })
}

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createRouter>
  }
  // Routes opt out of heavy SKU-store hydration (variants + forecasts) via skipSkuStoreData.
  interface StaticDataRouteOption {
    skipSkuStoreData?: boolean
  }
}
